import { render, staticRenderFns } from "./ask-paper.vue?vue&type=template&id=7955be6a&scoped=true"
import script from "./ask-paper.vue?vue&type=script&lang=ts"
export * from "./ask-paper.vue?vue&type=script&lang=ts"
import style0 from "./ask-paper.vue?vue&type=style&index=0&id=7955be6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7955be6a",
  null
  
)

export default component.exports